import {useEffect} from 'react';
import {BrowserRouter} from 'react-router';
import Main from './pages/Main.tsx';
import useCenterStore from './store/useCenterStore.ts';

function App() {
    useEffect(() => {
        const cleanup = () => {
            // 앱 종료 시 모든 미디어 스트림 정리
            const {mediaStream, captureBoardMediaStream} = useCenterStore.getState();
            if (mediaStream) {
                mediaStream.getTracks().forEach((track) => track.stop());
            }
            if (captureBoardMediaStream) {
                captureBoardMediaStream.getTracks().forEach((track) => track.stop());
            }
        };

        window.addEventListener('beforeunload', cleanup);
        return () => {
            window.removeEventListener('beforeunload', cleanup);
            cleanup();
        };
    }, []);

    return (
        <BrowserRouter>
            <Main />
        </BrowserRouter>
    );
}

export default App;
